import { render, staticRenderFns } from "./SwamtStart.vue?vue&type=template&id=0002ff6a&scoped=true"
import script from "./SwamtStart.vue?vue&type=script&lang=js"
export * from "./SwamtStart.vue?vue&type=script&lang=js"
import style0 from "./SwamtStart.vue?vue&type=style&index=0&id=0002ff6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002ff6a",
  null
  
)

export default component.exports